import moment from "moment";
import { useTranslation } from "react-i18next";

import { Box, Typography } from "@mui/material";

import FileIcon from "../../../../assets/FileIconBlue.svg";
import { FilePreviewModal } from "../../../../components/filePreview/FilePreviewModal";
import DocumentActionIcons from "./DocumentActionIcons";
import { useDocumentActions } from "./useDocumentActions";

// Lists the files that are not tied to a required document slot.
export default function DocumentList(props: any) {
  const { t } = useTranslation();
  const { dynamicConfig, isLoanSubmitted, setDocumentList, documentList } =
    props;

  const { preview, viewFile, handleDownloadDocument, handleDeleteDocument } =
    useDocumentActions({
      dynamicConfig,
      documentList,
      setDocumentList,
      getChecklistPayload: props.getChecklistPayload,
    });
  const { previewData, loading, error, closePreview } = preview;

  const otherDocuments = (documentList ?? []).filter(
    (doc: any) => !doc.isDeleted && !doc.requiredDocumentKey,
  );

  return (
    <Box
      sx={{
        borderRadius: "14px",
        border: "1px solid #DBE2FF",
        background: "#FFF",
        width: "50%",
        flex: "1 1 0",
        minWidth: 0,
      }}
      data-testid="other-documents"
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          background: "#F5F6FA",
          padding: "24px 24px 8px 24px",
        }}
      >
        <h3
          style={{
            fontFamily: "Poppins",
            fontSize: 16,
            fontWeight: 700,
            margin: "0 0 8px",
            color: "#32325d",
          }}
        >
          {t("otherDocuments")}
        </h3>
        <span style={{ fontSize: 12, fontWeight: 400, marginLeft: 8 }}>
          {t("filesCount", { count: otherDocuments.length })}
        </span>
      </div>

      <div style={{ padding: "0 24px 24px 24px" }}>
      <Box sx={{ maxHeight: 400, overflowY: "auto" }}>
        {otherDocuments.map((doc: any) => (
          <Box
            key={doc.id}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
              py: 1.5,
              borderTop: "1px solid #EEF0F6",
            }}
          >
            <Box
              sx={{
                width: 38,
                height: 38,
                flexShrink: 0,
                borderRadius: "8px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#F1F2F6",
              }}
            >
              <img src={FileIcon} alt="File" style={{ height: 22, width: 22 }} />
            </Box>
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography
                noWrap
                title={doc?.documentName ?? ""}
                sx={{ fontFamily: "Poppins", fontSize: 14, fontWeight: 500 }}
              >
                {doc?.documentName ?? ""}
              </Typography>
              <Typography
                noWrap
                sx={{ fontFamily: "Poppins", fontSize: 12, color: "#666" }}
              >
                {doc?.date ? moment(doc.date).format("MM/DD/YYYY · hh:mm A") : ""}
              </Typography>
            </Box>
            <DocumentActionIcons
              doc={doc}
              onView={viewFile}
              onDownload={handleDownloadDocument}
              onDelete={handleDeleteDocument}
              disableDelete={isLoanSubmitted}
            />
          </Box>
        ))}
      </Box>
      </div>
      <FilePreviewModal
        open={loading || !!previewData || !!error}
        loading={loading}
        error={error}
        previewData={previewData}
        onClose={closePreview}
      />
    </Box>
  );
}
